import CustomerSimplifiedDTO from 'features/customer/dtos/CustomerSimplifiedDTO';
import CustomerSelectSection from 'features/customer/sections/CustomerSelectSection';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface Props {
  
}

const AllCustomersSelect = (props: Props) => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const history = useHistory();

  // handlers
  const selectCustomerHandler = (customer: CustomerSimplifiedDTO): Promise<void> => {
    history.push({
      pathname: `customers/${customer.customerId}/accounts`,
      state: customer
    });
    
    return Promise.resolve();
  };

  // render
  return (
    <>
      <Header
          title={tLabels("allCustomerSelect.title")}
          subtitle={tLabels("allCustomerSelect.subtitle")}
          includeBreadcrumbs
      />
      <ModuleContent>
        <CustomerSelectSection 
          allCustomers
          automaticSelectCustomer={false}
          onCustomerClick={selectCustomerHandler}
        />
      </ModuleContent>
    </>
  )
}

export default AllCustomersSelect;
